<template>
    <div class="container" v-loading="true"/>
</template>
<script>
    import _ from 'lodash';
    import {APP_CONFIG} from "../../config";

    export default {
        data() {
            return {

            }
        },
        created() {
            if(_.includes(['github', 'google'], this.$route.params.provider)) {
                this.$store.dispatch('USER_LOGIN', {
                    channel: 'social',
                    code: this.$route.query.code,
                    provider: this.$route.params.provider
                }).catch(() => {
                    this.$notify({
                        message: 'An error was encountered while connecting to our servers',
                        title: 'Whoops!!',
                        type: "error"
                    })
                    this.$router.replace({name: 'login'})
                })
            } else {
                this.$notify({
                    message: 'Auth provider not supported',
                    type: 'error',
                    position: 'top-right',
                    title: 'Whoops!!'
                })
                this.$router.replace({name: 'signup'})
            }
        },
    }
</script>
